import React, { useState, useRef, useEffect } from "react";

import { API_BASE_URL } from '../../lib/constants';
import {
  Container,
  TextField,
  Typography,
  Paper,
  Button,
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
  Grid,
  Divider,
  IconButton,
  Autocomplete,
  ListSubheader,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  FormHelperText
} from "@mui/material";
import StopIcon from "@mui/icons-material/Stop";
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import SignatureCanvas from "react-signature-canvas";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import ShareIcon from '@mui/icons-material/Share';


import theme from '../../theme/theme';
import { ThemeProvider } from '@mui/material/styles';
import { useNotification } from '../../contexts/NotificationContext';
import DraftSaveButton from '../../components/DraftSaveButton';
import { DRAFT_KEYS, saveDraft, clearDraft, loadDraft, hasDraft } from '../../utils/draftUtils';

const HighRiskConsentForm = () => {
  const { showNotification } = useNotification();
  const navigate = useNavigate();
  const uhid_no = useParams().uhid_no;
  const [success, setSuccess] = useState(false);
  // const [loading, setLoading] = useState(true);
  const [patientError, setPatientError] = useState(null);
  // Voice-to-text audio upload states
  const [audioFile, setAudioFile] = useState(null);
  const [audioTranscription, setAudioTranscription] = useState("");
  const [audioLoading, setAudioLoading] = useState(false);
  const [audioError, setAudioError] = useState("");

  // Handle audio file selection
  function handleAudioFileChange(e) {
    setAudioFile(e.target.files[0]);
    setAudioError("");
    setAudioTranscription("");
  }

  // Send audio file to backend for transcription
  async function handleAudioTranscribe() {
    if (!audioFile) {
      setAudioError("Please select an audio file.");
      return;
    }
    setAudioLoading(true);
    setAudioError("");
    try {
      const formData = new FormData();
      formData.append('audio', audioFile);
      const response = await axios.post(`${API_BASE_URL}/transcribe-audio`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setAudioTranscription(response.data.transcription);
      // Optionally, set the transcription to a form field
      setFormData(prev => ({ ...prev, primary_disease: response.data.transcription }));
    } catch (error) {
      setAudioError("Failed to transcribe audio.");
    }
    setAudioLoading(false);
  }

  const [errors, setErrors] = useState({});
  const [signatureDialogOpen, setSignatureDialogOpen] = useState(false);
  const [currentSignatureRole, setCurrentSignatureRole] = useState("");
  const signaturePadRef = useRef(null);



  const [formData, setFormData] = useState({
    ip_no: "",
    uhid_no: uhid_no || "",
    hospital_id: 1,
    procedure_by_dr: "",
    primary_disease: "",
    associated_risk_factor: "",
    complications: "",
    patient_signature: "",
    patient_name: "",
    patient_signature_date_time: "",
    witness_signature: "",
    witness_name: "",
    witness_signature_date_time: "",
    doctor_anaesthetist_signature: "",
    doctor_anaesthetist_patient_name: "",
    doctor_anaesthetist_signature_date_time: "",
    interpreter_signature: "",
    interpreter_name: "",
    interpreter_signature_date_time: "",
    unable_consent_reason: "",
    attender_name: "",
    patient_rep_signature: "",
    patient_rep_patient_name: "",
    patient_rep_signature_date_time: "",
    witness_signature_unable_consent: "",
    witness_name_unable_consent: "",
    witness_signature_unable_consent_date_time: "",
    doctor_signature_unable_consent: "",
    doctor_signature_unable_consent_patient_name: "",
    doctor_signature_unable_consent_date_time: "",
    interpreter_signature_unable_consent: "",
    interpreter_name_unable_consent: "",
    interpreter_signature_unable_consent_date_time: ""
  });

  const handleHighRickConsentSubmit = async (event) => {
    event.preventDefault();
    console.log(formData);
    const highRiskConsentData = {

      ip_no: formData.ip_no,

      uhid_no: formData.uhid_no,
      hospital_id: 1,
      procedure_by_dr: formData.procedure_by_dr,
      primary_disease: formData.primary_disease,
      associated_risk_factor: formData.associated_risk_factor,
      complications: formData.complications,
      patient_signature: formData.patient_signature,
      patient_name: formData.patient_name,
      patient_signature_date_time: formData.patient_signature_date_time,
      witness_signature: formData.witness_signature,
      witness_name: formData.witness_name,
      witness_signature_date_time: formData.witness_signature_date_time,
      doctor_anaesthetist_signature: formData.doctor_anaesthetist_signature,
      doctor_anaesthetist_patient_name: formData.doctor_anaesthetist_patient_name,
      doctor_anaesthetist_signature_date_time: formData.doctor_anaesthetist_signature_date_time,
      interpreter_signature: formData.interpreter_signature,
      interpreter_name: formData.interpreter_name,
      interpreter_signature_date_time: formData.interpreter_signature_date_time,
      unable_consent_reason: formData.unable_consent_reason,
      attender_name: formData.attender_name,
      patient_rep_signature: formData.patient_rep_signature,
      patient_rep_patient_name: formData.patient_rep_patient_name,
      patient_rep_signature_date_time: formData.patient_rep_signature_date_time,
      witness_signature_unable_consent: formData.witness_signature_unable_consent,
      witness_name_unable_consent: formData.witness_name_unable_consent,
      witness_signature_unable_consent_date_time: formData.witness_signature_unable_consent_date_time,
      doctor_signature_unable_consent: formData.doctor_signature_unable_consent,
      doctor_signature_unable_consent_patient_name: formData.doctor_signature_unable_consent_patient_name,
      doctor_signature_unable_consent_date_time: formData.doctor_signature_unable_consent_date_time,
      interpreter_signature_unable_consent: formData.interpreter_signature_unable_consent,
      interpreter_name_unable_consent: formData.interpreter_name_unable_consent,
      interpreter_signature_unable_consent_date_time: formData.interpreter_signature_unable_consent_date_time
    };

    const newErrors = {};
    Object.keys(formData).forEach(key => {
      if (typeof formData[key] === 'string' && formData[key].trim() === "" &&
        !key.includes('signature') && !key.includes('date_time') &&
        !['ip_no', 'uhid_no', 'hospital_id'].includes(key)) {
        newErrors[key] = "This field is required";
      }
    });
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      const firstError = Object.values(newErrors)[0];
      showNotification('error', `Required Field: ${firstError}`);
      return;
    }

    try {

      if (success) {
        const responseUpdate = await axios.put(`${API_BASE_URL}/update_consent_high_risk/${uhid_no}`, highRiskConsentData, { withCredentials: true });

        showNotification('success', 'Consent for high risk form updated successfully!');
      } else {

        const response = await axios.post(`${API_BASE_URL}/create_consent_high_risk`, highRiskConsentData, { withCredentials: true });
        showNotification('success', 'Consent for high risk form submitted successfully!');

      }
      clearSavedData();
      navigate(`/mainPage/${formData.uhid_no}`, {
        state: { from: 'PreOperativePhase', status: 'success', step: 1 },
      });
    } catch (error) {
      console.error('There was an error submitting the form!', error);
      showNotification('error', 'Error in submitting High Risk Consent Form!');
    }
  };

  const handleBlur = (event) => {
    const { name, value } = event.target;
    let error = "";
    if (!value || !String(value).trim()) {
      error = "This field is required";
    }
    setErrors(prev => ({ ...prev, [name]: error }));
  };

  const handleSignatureClose = () => {
    setSignatureDialogOpen(false);
  };

  const handleSignatureClear = () => {
    if (signaturePadRef.current) {
      signaturePadRef.current.clear();
    }
  };

  const handleSignatureSave = () => {
    if (!signaturePadRef.current || signaturePadRef.current.isEmpty()) {
      showNotification('warning', 'Please provide a signature before saving.');
      return;
    }

    try {
      const dataURL = signaturePadRef.current.toDataURL('image/png');
      const base64 = dataURL.replace(/^data:image\/png;base64,/, '');

      if (base64.length < 100) {
        showNotification('warning', 'Signature appears to be too small. Please try signing again.');
        return;
      }

      setFormData((prevData) => ({
        ...prevData,
        [currentSignatureRole]: base64,
      }));

      setSignatureDialogOpen(false);
    } catch (error) {
      console.error('Error saving signature:', error);
      showNotification('error', 'Error saving signature. Please try again.');
    }
  };

  const validateField = (name, value) => {
    handleBlur({ target: { name, value } });
  };







  const handleChange = (event) => {
    const { name, type, checked } = event.target;
    let value = type === 'checkbox' ? checked : event.target.value;

    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
    validateField(name, value);
  };


  const signatureDatetimeMap = {
    // First consent section
    patient_signature: "patient_signature_date_time",
    witness_signature: "witness_signature_date_time",
    doctor_anaesthetist_signature: "doctor_anaesthetist_signature_date_time",
    interpreter_signature: "interpreter_signature_date_time",

    // Unable to consent section
    patient_rep_signature: "patient_rep_signature_date_time",
    witness_signature_unable_consent: "witness_signature_unable_consent_date_time",
    doctor_signature_unable_consent: "doctor_signature_unable_consent_date_time",
    interpreter_signature_unable_consent: "interpreter_signature_unable_consent_date_time"
  };


  const handleSignatureOpen = (signatureKey) => {
    const datetimeKey = signatureDatetimeMap[signatureKey];

    if (datetimeKey && !formData[datetimeKey]) {
      const now = new Date().toISOString().slice(0, 16); // "YYYY-MM-DDTHH:mm"
      setFormData((prev) => ({
        ...prev,
        [datetimeKey]: now
      }));
    }


    setCurrentSignatureRole(signatureKey); // So we can save it in handleSignatureSave
    setSignatureDialogOpen(true);
  };


  // const handleSignatureChange = (role, value) => {
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     signature: {
  //       ...prevData.signature,
  //       [role]: value,
  //     },
  //   }));
  // };

  const handleNameChange = (e) => {
    const regex = /^[a-zA-Z\s.-]*$/;
    const { name, value } = e.target;
    if (value === '' || regex.test(value)) {
      setFormData(prev => ({ ...prev, [name]: value }));
      validateField(name, value);
    }
  };

  // Voice recognition states
  const [listening, setListening] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [speechSupported, setSpeechSupported] = useState(false);
  const [micPermission, setMicPermission] = useState('prompt');
  const [voiceError, setVoiceError] = useState('');
  const [showVoiceError, setShowVoiceError] = useState(false);

  // Refs for speech recognition
  const recognitionRef = useRef(null);
  const finalTranscriptRef = useRef("");
  const restartTimeoutRef = useRef(null);
  const initializeSpeechRecognition = async () => {
    try {
      // Check if we're on HTTPS or localhost
      const isSecure = window.location.protocol === 'https:' || window.location.hostname === 'localhost';

      if (!isSecure) {
        setVoiceError('Voice recognition requires HTTPS connection for mobile devices');
        setShowVoiceError(true);
        return;
      }

      // Check for browser support
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

      if (!SpeechRecognition) {
        setVoiceError('Speech recognition not supported in this browser');
        setShowVoiceError(true);
        return;
      }

      // Request microphone permission explicitly
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        stream.getTracks().forEach(track => track.stop()); // Stop the stream immediately
        setMicPermission('granted');
      } catch (permError) {
        console.error('Microphone permission denied:', permError);
        setVoiceError('Microphone access denied. Please allow microphone access.');
        setShowVoiceError(true);
        setMicPermission('denied');
        return;
      }

      // Initialize speech recognition
      recognitionRef.current = new SpeechRecognition();

      // Enhanced configuration for mobile
      recognitionRef.current.continuous = true;
      recognitionRef.current.interimResults = true;
      recognitionRef.current.lang = "en-US";
      recognitionRef.current.maxAlternatives = 1;

      // Mobile-specific settings
      if (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        recognitionRef.current.continuous = false; // Better for mobile
      }

      recognitionRef.current.onstart = () => {
        console.log('Speech recognition started');
        setListening(true);
        setVoiceError('');
      };

      recognitionRef.current.onresult = (event) => {
        let interimTranscript = "";
        let finalTranscript = "";

        for (let i = event.resultIndex; i < event.results.length; i++) {
          const transcript = event.results[i][0].transcript;

          if (event.results[i].isFinal) {
            finalTranscript += transcript + " ";
            finalTranscriptRef.current += transcript + " ";
          } else {
            interimTranscript += transcript + " ";
          }
        }

        // Update form data only if user is not manually editing
        if (!isEditing) {
          setFormData((prevState) => ({
            ...prevState,
            primary_disease: finalTranscriptRef.current + interimTranscript,
          }));
        }
      };

      recognitionRef.current.onerror = (event) => {
        console.error('Speech recognition error:', event.error);

        let errorMessage = 'Voice recognition error occurred';

        switch (event.error) {
          case 'network':
            errorMessage = 'Network error. Please check your internet connection.';
            break;
          case 'not-allowed':
          case 'service-not-allowed':
            errorMessage = 'Microphone access denied. Please allow microphone access.';
            setMicPermission('denied');
            break;
          case 'no-speech':
            errorMessage = 'No speech detected. Please try again.';
            break;
          case 'audio-capture':
            errorMessage = 'No microphone found or audio capture failed.';
            break;
          case 'aborted':
            errorMessage = 'Speech recognition was aborted.';
            break;
          default:
            errorMessage = `Speech recognition error: ${event.error}`;
        }

        setVoiceError(errorMessage);
        setShowVoiceError(true);
        setListening(false);
      };

      recognitionRef.current.onend = () => {
        console.log('Speech recognition ended');
        setListening(false);

        // Auto-restart for continuous listening on mobile (if still intended to listen)
        if (listening && /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          restartTimeoutRef.current = setTimeout(() => {
            if (recognitionRef.current && listening) {
              try {
                recognitionRef.current.start();
              } catch (error) {
                console.error('Error restarting recognition:', error);
              }
            }
          }, 100);
        }
      };

      setSpeechSupported(true);

    } catch (error) {
      console.error('Error initializing speech recognition:', error);
      setVoiceError('Failed to initialize voice recognition');
      setShowVoiceError(true);
    }
  };

  // Initialize speech recognition on component mount
  useEffect(() => {
    initializeSpeechRecognition();

    return () => {
      if (recognitionRef.current) {
        recognitionRef.current.stop();
      }
      if (restartTimeoutRef.current) {
        clearTimeout(restartTimeoutRef.current);
      }
    };
  }, []);

  const startListening = async () => {
    if (!speechSupported) {
      setVoiceError('Speech recognition not available');
      setShowVoiceError(true);
      return;
    }

    if (micPermission === 'denied') {
      setVoiceError('Microphone access denied. Please allow microphone access in your browser settings.');
      setShowVoiceError(true);
      return;
    }

    try {
      // Reset transcript
      finalTranscriptRef.current = formData.primary_disease || "";

      if (recognitionRef.current) {
        recognitionRef.current.start();
        setListening(true);
        setVoiceError('');
      }
    } catch (error) {
      console.error('Error starting speech recognition:', error);

      if (error.name === 'InvalidStateError') {
        // Recognition is already running, stop and restart
        recognitionRef.current.stop();
        setTimeout(() => {
          try {
            recognitionRef.current.start();
          } catch (restartError) {
            console.error('Error restarting recognition:', restartError);
            setVoiceError('Failed to start voice recognition');
            setShowVoiceError(true);
          }
        }, 100);
      } else {
        setVoiceError('Failed to start voice recognition');
        setShowVoiceError(true);
      }
    }
  };

  const stopListening = async () => {
    if (recognitionRef.current) {
      recognitionRef.current.stop();
      setListening(false);
    }

    if (restartTimeoutRef.current) {
      clearTimeout(restartTimeoutRef.current);
    }

    // Process the speech text with backend when stopping
    if (formData.primary_disease && formData.primary_disease.trim()) {
      try {
        const processedText = await processSpeechText(formData.primary_disease);
        setFormData((prev) => ({
          ...prev,
          primary_disease: processedText,
        }));
      } catch (error) {
        console.error('Error processing speech text:', error);
        // Keep original text if processing fails
      }
    }
  };

  // Process speech text locally
  const processSpeechText = (text) => {
    if (!text.trim()) return text;

    try {
      // Basic processing: capitalize first letter, remove extra spaces
      let processed_text = text.charAt(0).toUpperCase() + text.slice(1);
      processed_text = processed_text.split(' ').filter(word => word).join(' ');
      return processed_text;
    } catch (error) {
      console.error('Error processing speech text:', error);
      return text; // Return original text if processing fails
    }
  };



  useEffect(() => {
    const fetchAllInitialData = async () => {
      try {
        if (uhid_no) {
          // Fetch existing consent data
          const consentRes = await axios.get(`${API_BASE_URL}/get_consent_high_risk/${uhid_no}`);
          const data = consentRes.data;

          // Fetch patient name
          const patientRes = await axios.get(`${API_BASE_URL}/get_patient/${uhid_no}`);
          const patientName = patientRes.data.name;

          // Define date fields that need formatting
          const dateFields = [
            "doctor_anaesthetist_signature_date_time",
            "doctor_signature_unable_consent_date_time",
            "interpreter_signature_date_time",
            "interpreter_signature_unable_consent_date_time",
            "patient_rep_signature_date_time",
            "patient_signature_date_time",
            "witness_signature_date_time",
            "witness_signature_unable_consent_date_time",
          ];

          // Format date fields into "YYYY-MM-DDTHH:mm"
          const formattedDates = dateFields.reduce((acc, field) => {
            if (data[field]) {
              acc[field] = new Date(data[field]).toISOString().slice(0, 16);
            }
            return acc;
          }, {});


          // Sanitize data: replace null with empty string for all fields
          const sanitizedData = Object.keys(data).reduce((acc, key) => {
            acc[key] = data[key] === null ? '' : data[key];
            return acc;
          }, {});

          setFormData({
            ...sanitizedData,
            ...formattedDates,
            uhid_no: uhid_no,
            patient_name: patientName || '', // Set patient name from fetched data
          });

          setSuccess(true);
        } else {
          // Only fetch IP number if creating a new form
          const ipRes = await axios.get(`${API_BASE_URL}/highrisk_next_ip`);
          setFormData(prev => ({
            ...prev,
            ip_no: ipRes.data.next_ip_no,
          }));
        }
      } catch (error) {
        console.error('Error fetching initial data:', error);
        // Handle error cases appropriately
      }
    };

    fetchAllInitialData();
  }, [uhid_no]); // Depend on uhid_no to re-run when it changes


  // axios.get('${API_BASE_URL}/highrisk_next_uhid'),
  const [loading, setLoading] = useState(false);
  const [patient, setPatient] = useState(null);
  const [error, setError] = useState(null);

  const fetchPatientData = async (uhidNo) => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/get_patient/${uhidNo}`);
      setPatient(response.data);
      console.log(response.data);
      setFormData(prev => ({
        ...prev,

        name: response.data.name

      }));
      setLoading(false);
    } catch (error) {
      console.error('Error fetching patient data:', error);
      setPatientError('Failed to fetch patient data. Please try again.');
      setLoading(false);
    }
  };
  const doctorOptions = [
    'Dr. John Smith',
    'Dr. Emily Clark',
    'Dr. Robert Lee',
    'Dr. Alice Johnson',
    'Dr. Michael Brown',
  ];
  const diseaseOptions = [
    'Hypertension',
    'Diabetes Mellitus',
    'Asthma',
    'Pneumonia',
    'COVID-19',
    'Tuberculosis',
    'Anemia',
    'Heart Failure',
  ];
  const riskFactorOptions = [
    'Smoking',
    'Obesity',
    'Hypertension',
    'Diabetes',
    'High Cholesterol',
    'Physical Inactivity',
    'Family History',
  ];
  const complicationsOptions = [
    'Diabetes',
    'Hypertension',
    'Asthma',
    'Heart Disease',
    'Stroke',
    'Chronic Kidney Disease',
    'COPD',
    'Liver Cirrhosis',
    'Anemia',
    'Arthritis',
    'Obesity',
    'Cancer',
    'Thyroid Disorder',
    'Depression',
    'Anxiety',
    'Osteoporosis',
    'Gastroesophageal Reflux Disease (GERD)',
    'Sleep Apnea',
    'Allergies',
    'Autoimmune Disease',
    'Peripheral Artery Disease',
    'Infections',
    'Sepsis',
    'Pulmonary Embolism',
    'Venous Thromboembolism',
    'Pregnancy Complications',
  ];
  const unableConsentReasons = [
    "Patient unconscious",
    "Patient sedated",
    "Cognitive impairment",
    "Severe pain or distress",
    "Emergency situation",
    "Language barrier",
    "Hearing impairment",
    "Developmental disability",
    "Under influence of medication or substances",
  ];
  const [savedData, setSavedData] = useState(null);
  const [showSaveNotification, setShowSaveNotification] = useState(false);
  const [currentPage, setCurrentPage] = useState('form');
  const [dataLoaded, setDataLoaded] = useState(false);
  // Auto-save functionality
  // Auto-save functionality - only after initial data is loaded
  useEffect(() => {
    if (!dataLoaded) return; // Don't auto-save until initial data is loaded

    const timeoutId = setTimeout(() => {
      if (hasFormData()) {
        saveFormData(formData);
        setShowSaveNotification(true);
        setTimeout(() => setShowSaveNotification(false), 2000);
      }
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [formData, dataLoaded]);

  // Save form data to sessionStorage
  const saveFormData = (data) => {
    sessionStorage.setItem(`high_riskForm_${uhid_no}`, JSON.stringify(data));
    console.log('Form data saved:', data);
  };

  // Get saved form data
  const getSavedFormData = () => {
    const saved = sessionStorage.getItem(`high_riskForm_${uhid_no}`);
    return saved ? JSON.parse(saved) : null;
  };
  useEffect(() => {
    const saved = getSavedFormData();
    if (saved && Object.keys(saved).length > 0) {
      setSavedData(saved);
      setFormData(saved);
    }
    setDataLoaded(true); // Set dataLoaded to true after loading draft
  }, []);

  useEffect(() => {
    if (uhid_no && hasDraft(DRAFT_KEYS.HIGH_RISK_CONSENT, uhid_no)) {
      const saved = loadDraft(DRAFT_KEYS.HIGH_RISK_CONSENT, uhid_no);
      if (saved && saved.formData) {
        setFormData(prev => ({ ...prev, ...saved.formData }));
      }
    }
  }, [uhid_no]);

  // Check if form has any data
  const hasFormData = () => {
    return Object.values(formData).some(value => {
      if (typeof value === 'string') return value.trim() !== '';
      if (typeof value === 'object' && value !== null) {
        return Object.values(value).some(subValue =>
          typeof subValue === 'string' ? subValue.trim() !== '' : subValue
        );
      }
      return value === true;
    });
  };

  // Clear saved data - ONLY called on successful submit
  const clearSavedData = () => {
    try {
      clearDraft(DRAFT_KEYS.HIGH_RISK_CONSENT, uhid_no);
    } catch (e) {
      console.error('Failed to clear draft:', e);
    }
    sessionStorage.removeItem(`formStatus_high_risk_${uhid_no}`);
  };
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [ipRes] = await Promise.all([

          axios.get(`${API_BASE_URL}/highrisk_next_ip`)
        ]);
        setFormData(prev => ({
          ...prev,

          ip_no: ipRes.data.next_ip_no
        }));
      } catch (error) {
        console.error('Failed to fetch initial data:', error);
      }
    };

    fetchInitialData();
  }, []);
  // Home button handler
  const handleHomeNavigation = () => {
    if (hasFormData()) {
      // Save a lightweight draft without base64 signatures
      try {
        const draftData = {
          ...formData,
          patient_signature: '',
          witness_signature: '',
          doctor_anaesthetist_signature: '',
          interpreter_signature: '',
          patient_rep_signature: '',
          witness_signature_unable_consent: '',
          doctor_signature_unable_consent: '',
          interpreter_signature_unable_consent: ''
        };
        saveDraft(DRAFT_KEYS.HIGH_RISK_CONSENT, uhid_no, draftData);
      } catch (e) {
        console.error('Failed to save draft on Home navigation:', e);
      }
      // Store form status for home page to show "Continue" button
      sessionStorage.setItem(`formStatus_high_risk_${uhid_no}`, JSON.stringify({
        formName: 'CONSENT FOR HIGH RISK',
        uhid_no: uhid_no,
        status: 'incomplete',
        lastSaved: new Date().toISOString(),
        continueUrl: `/highRiskConsentForm/${uhid_no}`
      }));
    }
    navigate('/home');
  };
  const handleBack = () => {
    navigate(`/mainPage/${uhid_no}`, {
      state: { from: 'PreOperativePhase', status: 'success', step: 1 },
    });
  };
  const goToVideoRecorder = (formName, uhid_no) => {
    navigate(`/video?form=${encodeURIComponent(formName)}&uhid_no=${encodeURIComponent(uhid_no)}`);
  };
  const [submitStatus, setSubmitStatus] = useState({
    open: false,
    message: "",
    severity: "success"
  });
  const handleShareClick = async () => {
    try {
      // Call API to generate a share token for the given UHID
      const res = await axios.post(`${API_BASE_URL}/generate_for_medical_highrisk_api_token/${uhid_no}`);

      const token = res.data.token;
      const link = `${API_BASE_URL}/highRiskConsentForm/${uhid_no}?token=${token}`;
      const message = `Dear Doctor,

Please fill the post-operative analgesia chart:

${link}`;

      // Copy the shareable link to clipboard
      await navigator.clipboard.writeText(link);

      // Show success notification to user
      setSubmitStatus({
        open: true,
        message: "Secure link copied to clipboard!",
        severity: "info",
      });

      // Open WhatsApp chat with pre-filled message (replace phone number if needed)
      const phoneNumber = '+916379605575'; // no spaces or special chars for wa.me
      window.open(`http://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
    } catch (error) {
      console.error("Error generating share token:", error);

      // Show error notification to user
      setSubmitStatus({
        open: true,
        message: "Failed to generate shareable link",
        severity: "error",
      });
    }
  };
  const doctorGroups = {
    Cardiologists: [
      "Dr. John Smith",
      "Dr. Emily Johnson",
      "Dr. Michael Brown",
      "Dr. Sarah Davis",
      "Dr. William Wilson",
      "Dr. Linda Martinez"
    ],
    Neurologists: [
      "Dr. Robert Lee",
      "Dr. Patricia Taylor",
      "Dr. James Anderson",
      "Dr. Barbara Thomas",
      "Dr. David Jackson",
      "Dr. Susan White"
    ],
    Orthopedics: [
      "Dr. Richard Garcia",
      "Dr. Jennifer Harris",
      "Dr. Charles Clark",
      "Dr. Jessica Lewis",
      "Dr. Thomas Robinson",
      "Dr. Karen Walker"
    ],
    Dermatologists: [
      "Dr. Nancy Young",
      "Dr. Matthew Hall",
      "Dr. Donna Allen",
      "Dr. Steven King",
      "Dr. Michelle Wright",
      "Dr. George Scott"
    ],
    Gynecologists: [
      "Dr. Sandra Green",
      "Dr. Kevin Adams",
      "Dr. Laura Baker",
      "Dr. Mark Nelson",
      "Dr. Angela Carter",
      "Dr. Brian Mitchell"
    ],
    Pediatricians: [
      "Dr. Melissa Perez",
      "Dr. Eric Roberts",
      "Dr. Deborah Turner",
      "Dr. Jason Phillips",
      "Dr. Rebecca Campbell",
      "Dr. Andrew Parker"
    ],
    AnaesthesiaSpecialists: [
      "Dr. Anil Mehta",
      "Dr. Priya Iyer",
      "Dr. Rakesh Nair",
      "Dr. Neha Sharma",
      "Dr. Vivek Rao",
      "Dr. Aarti Desai"
    ]
  };
  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth="md">
        <Paper elevation={3} sx={{ padding: 3, mt: 3 }}>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 2 }}>
            {/* Heading with Icon */}
            <Typography
              variant="h4"
              sx={{
                color: '#008080',
                display: 'flex',
                alignItems: 'center',
                fontWeight: 600,
                letterSpacing: 0.5,
              }}
            >

              CONSENT FOR HIGH RISK
            </Typography>

            {/* Right-aligned Logo and Text */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <img src="/logo.png" alt="Logo" className="w-8 h-8" />
              <Typography
                variant="h6"
                sx={{
                  color: '#008080',
                  marginLeft: 1,
                  fontWeight: 500,
                  letterSpacing: 0.3,
                }}
              >
                OTMS
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
            {/* Left-aligned Back Button */}
            <Button
              variant="outlined"
              onClick={handleBack}
              sx={{ marginLeft: 2 }}
            >
              Back
            </Button>

            {/* Right-aligned Buttons */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Button
                variant="contained"
                onClick={handleHomeNavigation}
                sx={{ marginRight: 1 }}
              >
                Home
              </Button>
              <Button
                variant="contained"
                onClick={() => goToVideoRecorder("CONSENT FOR HIGH RISK", uhid_no)}
                sx={{ marginRight: 1 }}
              >
                Add Iterative Video
              </Button>
              <IconButton color="primary" aria-label="share" onClick={handleShareClick}>
                <ShareIcon />
              </IconButton>
            </Box>
          </Box>
          <br></br>
          {/* Voice-to-text audio upload section */}
          {/* <Box sx={{ mb: 2, p: 2, border: '1px solid #eee', borderRadius: 2, background: '#fafafa' }}>
          <Typography variant="h6" sx={{ mb: 1 }}>Voice to Text Converter (Audio Upload)</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <input type="file" accept="audio/*" onChange={handleAudioFileChange} />
            <Button variant="contained" color="primary" onClick={handleAudioTranscribe} disabled={audioLoading || !audioFile}>
              {audioLoading ? 'Transcribing...' : 'Transcribe Audio'}
            </Button>
          </Box>
          {audioError && <Typography color="error" sx={{ mt: 1 }}>{audioError}</Typography>}
          {audioTranscription && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle1">Transcription Result:</Typography>
              <Paper sx={{ p: 2, mt: 1, background: '#f5f5f5' }}>{audioTranscription}</Paper>
            </Box>
          )}
        </Box> */}
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                name="ip_no"
                label="IP No."
                value={formData.ip_no}
                InputProps={{ readOnly: true, }}
                fullWidth
                onChange={handleChange}

              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="uhid_no"
                label="UHID No."
                InputProps={{ readOnly: true, }}
                onChange={handleChange}
                value={formData.uhid_no}
              />
            </Grid>
          </Grid>
          <br></br>
          {/* Doctor & Disease Details */}
          <Typography variant="body1">
            I have been explained about the following medical condition and the
            proposed surgery / procedure by
          </Typography>
          <FormControl fullWidth sx={{ mt: 1 }} error={!!errors.procedure_by_dr}>
            <InputLabel id="procedure-by-dr-label">Doctor's Name</InputLabel>
            <Select
              labelId="procedure-by-dr-label"
              id="procedure-by-dr"
              name="procedure_by_dr"
              value={formData.procedure_by_dr || ''}
              label="Doctor's Name"
              onChange={handleChange}
              onBlur={handleBlur}
            >
              <MenuItem value="">
                <em>Select Doctor</em>
              </MenuItem>

              {Object.entries(doctorGroups).map(([specialty, doctors]) => [
                <ListSubheader key={specialty}>{specialty}</ListSubheader>,
                doctors.map((doctor, idx) => (
                  <MenuItem key={`${specialty}-${idx}`} value={doctor}>
                    {doctor}
                  </MenuItem>
                )),
              ])}
            </Select>
            {errors.procedure_by_dr && <Typography color="error" variant="caption">{errors.procedure_by_dr}</Typography>}
          </FormControl>
          {/* <Autocomplete
  freeSolo
  options={doctorOptions}
  value={formData.procedure_by_dr || ''}
  onChange={handleChange}
  onInputChange={(event, newInputValue) => {
    // Also sanitize input while typing
    const filteredInput = newInputValue.replace(/[^a-zA-Z\s'-]/g, '');
    if (filteredInput !== formData.procedure_by_dr) {
      handleChange({
        target: {
          name: 'procedure_by_dr',
          value: filteredInput,
        },
      });
    }
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      fullWidth
      variant="outlined"
      placeholder="Doctor's Name"
      sx={{ mt: 1 }}
      name="procedure_by_dr"
    />
  )}
/> */}

          <Typography variant="h6" sx={{ mt: 2 }}>
            Primary Disease:
          </Typography>

          <Paper
            elevation={3}
            sx={{
              p: 1.25,
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <Autocomplete
              freeSolo
              options={diseaseOptions}
              value={formData.primary_disease}
              onChange={(event, newValue) => {
                setFormData((prev) => ({
                  ...prev,
                  primary_disease: newValue || '',
                }));
                validateField('primary_disease', newValue || '');
              }}
              onInputChange={(event, newInputValue) => {
                setFormData((prev) => ({
                  ...prev,
                  primary_disease: newInputValue,
                }));
                validateField('primary_disease', newInputValue);
              }}
              onFocus={() => setIsEditing(true)}
              onBlur={(event) => {
                setIsEditing(false);
                handleBlur(event);
              }}
              sx={{ flexGrow: 1 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label={<span>Primary Disease <span style={{ color: 'red' }}>*</span></span>}
                  placeholder="Enter primary disease"
                  name="primary_disease"
                  fullWidth
                  error={!!errors.primary_disease}
                  helperText={errors.primary_disease}
                />
              )}
            />

            <IconButton
              color={listening ? 'secondary' : 'primary'}
              onClick={listening ? stopListening : startListening}
              size="large"
              disabled={!speechSupported}
              title={
                !speechSupported
                  ? 'Voice recognition not available'
                  : listening
                    ? 'Stop recording'
                    : 'Start voice input'
              }
            >
              {!speechSupported ? (
                <MicOffIcon />
              ) : listening ? (
                <StopIcon />
              ) : (
                <MicIcon />
              )}
            </IconButton>
          </Paper>

          {/* Status indicator for voice recognition */}
          {speechSupported && (
            <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="caption" color={listening ? 'primary' : 'text.secondary'}>
                {listening ? '🎤 Listening...' : '🎤 Voice input ready'}
              </Typography>
              {micPermission === 'denied' && (
                <Typography variant="caption" color="error">
                  (Microphone access denied)
                </Typography>
              )}
            </Box>
          )}
          {showVoiceError && voiceError && (
            <Alert severity="error" sx={{ mt: 1 }}>{voiceError}</Alert>
          )}

          {/* Risk Factor & Complications */}
          <Typography variant="h6" sx={{ mt: 2 }}>
            I have been explained about the following:
          </Typography>
          <Typography variant="body1">1. Associated Risk factor:</Typography>
          <Autocomplete
            freeSolo
            options={riskFactorOptions}
            value={formData.associated_risk_factor || ''}
            onChange={(event, newValue) => {
              handleChange({
                target: {
                  name: 'associated_risk_factor',
                  value: newValue || '',
                },
              });
            }}
            onInputChange={(event, newInputValue) => {
              handleChange({
                target: {
                  name: 'associated_risk_factor',
                  value: newInputValue,
                },
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                variant="outlined"
                label={<span>Associated Risk factor <span style={{ color: 'red' }}>*</span></span>}
                placeholder="Enter associated risk factor"
                name="associated_risk_factor"
                error={!!errors.associated_risk_factor}
                helperText={errors.associated_risk_factor}
                onBlur={handleBlur}
              />
            )}
          />

          <Typography variant="body1" sx={{ mt: 2 }}>2. Complications:</Typography>
          <Autocomplete
            freeSolo
            options={complicationsOptions}
            value={formData.complications}
            onChange={(event, newValue) => {
              // Update form data on autocomplete selection
              handleChange({
                target: { name: 'complications', value: newValue },
              });
            }}
            onInputChange={(event, newInputValue) => {
              // Update form data on typing
              handleChange({
                target: { name: 'complications', value: newInputValue },
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                name="complications"
                label={<span>Complications <span style={{ color: 'red' }}>*</span></span>}
                variant="outlined"
                error={!!errors.complications}
                helperText={errors.complications}
                onBlur={handleBlur}
                placeholder="List complications"
              />
            )}
          />

          {/* Risk & Consent Explanation */}
          <Typography variant="body1" sx={{ mt: 2 }}>
            In view of the above, I have been explained the risks of not having
            the procedure and that the proposed surgery / procedure carries a
            higher risk than normal.
          </Typography>
          <Typography variant="body1">
            I have been informed that I might need intensive care treatment after
            the procedure.
          </Typography>
          <Typography variant="body1" sx={{ mt: 1 }}>
            Having understood the above, I give my high-risk consent. I absolve
            Annai Arul Hospitals (P) Ltd., its doctor and the staff in the event
            of any complications.
          </Typography>

          {/* Surrogate Signature Section */}
          <Typography variant="h6" sx={{ marginTop: 3 }}>
            Signatures
          </Typography>
          <Grid container spacing={2}>
            {[
              {
                label: "Patient Representative with relationship",
                key: "patient_signature",
                key1: "patient_name",
                key2: "patient_signature_date_time"
              },
              {
                label: "Witness",
                key: "witness_signature",
                key1: "witness_name",
                key2: "witness_signature_date_time"
              },
              {
                label: "Doctor/Anaesthetist",
                key: "doctor_anaesthetist_signature",
                key1: "doctor_anaesthetist_patient_name",
                key2: "doctor_anaesthetist_signature_date_time"
              },
              {
                label: "Interpreter",
                key: "interpreter_signature",
                key1: "interpreter_name",
                key2: "interpreter_signature_date_time"
              }

            ].map((person, index) => (
              <Grid item xs={12} sm={6} key={index}>
                {person.label === "Doctor/Anaesthetist" ? (
                  <FormControl fullWidth sx={{ marginTop: 1 }} error={!!errors[person.key1]}>
                    <InputLabel id={`${person.key1}-label`}>
                      <span>Name ({person.label}) <span style={{ color: 'red' }}>*</span></span>
                    </InputLabel>
                    <Select
                      labelId={`${person.key1}-label`}
                      name={person.key1}
                      value={formData[person.key1]}
                      onChange={handleNameChange}
                      label={<span>Name ({person.label}) <span style={{ color: 'red' }}>*</span></span>}
                      onBlur={handleBlur}
                    >
                      <MenuItem value="">
                        <em>Select Doctor</em>
                      </MenuItem>
                      {doctorGroups["AnaesthesiaSpecialists"]?.map((doctor, idx) => (
                        <MenuItem key={idx} value={doctor}>
                          {doctor}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText error>{errors[person.key1] || ' '}</FormHelperText>
                  </FormControl>
                ) : (
                  <TextField
                    fullWidth
                    label={<span>Name ({person.label}) <span style={{ color: 'red' }}>*</span></span>}
                    variant="outlined"
                    value={formData[person.key1]}
                    name={person.key1}
                    sx={{ marginTop: 1 }}
                    onChange={handleNameChange}
                    error={!!errors[person.key1]}
                    helperText={errors[person.key1]}
                    onBlur={handleBlur}
                  />
                )}

                <TextField
                  name={person.key2}
                  value={formData[person.key2]}
                  fullWidth
                  label="Date"
                  variant="outlined"
                  sx={{ marginTop: 1 }}
                  type="datetime-local"
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  error={!!errors[person.key2]}
                  helperText={errors[person.key2]}
                  onBlur={handleBlur}
                />

                <Button variant="outlined" color="primary" sx={{ marginTop: 2 }} onClick={() => handleSignatureOpen(person.key)}> Sign Here </Button>
                {formData[person.key] && (
                  <Box sx={{ marginTop: 1, border: '1px solid #ccc', borderRadius: 1, padding: 1 }}>
                    <img
                      src={`data:image/png;base64,${formData[person.key]}`}
                      alt="Signature"
                      style={{
                        width: '100%',
                        height: 'auto',
                        maxHeight: '150px',
                        objectFit: 'contain'
                      }}
                      onError={(e) => {
                        console.error(`Signature image load error for ${person.key}:`, e);
                        e.target.style.display = 'none';
                      }}
                    />
                  </Box>
                )}
              </Grid>
            ))}
          </Grid>


          {/* Surrogate Consent */}
          <Divider sx={{ my: 2 }} />
          <Box sx={{ mt: 4, p: 3, border: '1px solid #ccc', borderRadius: '8px', backgroundColor: '#f9f9f9' }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', textAlign: 'center' }}>CONSENT OF PATIENT REPRENSETATIVE / SURROGATE / Children below 18 yrs / vulnearble patients</Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              The patient is unable to consent because:
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Autocomplete
                freeSolo
                options={unableConsentReasons}
                value={formData.unable_consent_reason}
                onInputChange={(event, newInputValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    unable_consent_reason: newInputValue,
                  }));
                  validateField('unable_consent_reason', newInputValue);
                }}
                sx={{ flex: 1 }}  // Make autocomplete take equal space
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="unable_consent_reason"
                    label="Reason Unable to Consent"
                    variant="outlined"
                    fullWidth  // ensure it fills its container
                    error={!!errors.unable_consent_reason}
                    helperText={errors.unable_consent_reason}
                    onBlur={handleBlur}
                  />
                )}
              />

              <Typography variant="body1" sx={{ mx: 2, whiteSpace: 'nowrap' }}>
                And I,
              </Typography>

              <TextField
                name="attender_name"
                value={formData.attender_name}
                label="Attender Name"
                onChange={handleNameChange}
                variant="outlined"
                sx={{ flex: 1 }}
                fullWidth  // ensure it fills its container
                error={!!errors.attender_name}
                helperText={errors.attender_name}
                onBlur={handleBlur}
              />
            </Box>


            <Typography variant="body1">
              (name/relationship to the patient) therefore consent for the
              procedure with the doctor's designee and hereby consent to this procedure.
            </Typography>
          </Box>
          <Divider sx={{ my: 2 }} />

          {/* Section: Signature */}
          <Typography variant="h6" sx={{ marginTop: 3 }}>
            Signatures
          </Typography>
          <Grid container spacing={2}>
            {[
              {
                label: "Patient Representative with relationship",
                key: "patient_rep_signature",
                key1: "patient_rep_patient_name",
                key2: "patient_rep_signature_date_time"
              },
              {
                label: "Witness",
                key: "witness_signature_unable_consent",
                key1: "witness_name_unable_consent",
                key2: "witness_signature_unable_consent_date_time"
              },
              {
                label: "Doctor/Anaesthetist",
                key: "doctor_signature_unable_consent",
                key1: "doctor_signature_unable_consent_patient_name",
                key2: "doctor_signature_unable_consent_date_time"
              },
              {
                label: "Interpreter",
                key: "interpreter_signature_unable_consent",
                key1: "interpreter_name_unable_consent",
                key2: "interpreter_signature_unable_consent_date_time"
              }
            ].map((person, index) => (
              <Grid item xs={12} sm={6} key={index}>
                {person.label === "Doctor/Anaesthetist" ? (
                  <FormControl fullWidth sx={{ marginTop: 1 }} error={!!errors[person.key1]}>
                    <InputLabel>{`Name (${person.label})`}</InputLabel>
                    <Select
                      name={person.key1}
                      value={formData[person.key1]}
                      onChange={handleNameChange}
                      label={`Name (${person.label})`}
                      onBlur={handleBlur}
                    >
                      <MenuItem value="">
                        <em>Select Doctor</em>
                      </MenuItem>
                      {doctorGroups["AnaesthesiaSpecialists"]?.map((doctor, idx) => (
                        <MenuItem key={idx} value={doctor}>
                          {doctor}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors[person.key1] && <FormHelperText>{errors[person.key1]}</FormHelperText>}
                  </FormControl>
                ) : (
                  <TextField
                    fullWidth
                    label={`Name (${person.label})`}
                    variant="outlined"
                    value={formData[person.key1]}
                    name={person.key1}
                    sx={{ marginTop: 1 }}
                    onChange={handleNameChange}
                    error={!!errors[person.key1]}
                    helperText={errors[person.key1]}
                    onBlur={handleBlur}
                  />
                )}

                <TextField
                  name={person.key2}
                  value={formData[person.key2]}
                  fullWidth
                  label="Date"
                  type="datetime-local"
                  variant="outlined"
                  sx={{ marginTop: 1 }}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  error={!!errors[person.key2]}
                  helperText={errors[person.key2]}
                  onBlur={handleBlur}
                />

                <Button variant="outlined" color="primary" sx={{ marginTop: 2 }} onClick={() => handleSignatureOpen(person.key)}> Sign Here </Button>
                {formData[person.key] && (
                  <Box sx={{ marginTop: 1, border: '1px solid #ccc', borderRadius: 1, padding: 1 }}>
                    <img
                      src={`data:image/png;base64,${formData[person.key]}`}
                      alt="Signature"
                      style={{
                        width: '100%',
                        height: 'auto',
                        maxHeight: '150px',
                        objectFit: 'contain'
                      }}
                      onError={(e) => {
                        console.error(`Signature image load error for ${person.key}:`, e);
                        e.target.style.display = 'none';
                      }}
                    />
                  </Box>
                )}
              </Grid>
            ))}
          </Grid>

          <Dialog open={signatureDialogOpen} onClose={() => setSignatureDialogOpen(false)} maxWidth="md" fullWidth>
            <DialogTitle>Provide Your Signature</DialogTitle>
            <DialogContent>
              <Box sx={{
                border: '2px solid #ccc',
                borderRadius: 1,
                padding: 1,
                backgroundColor: '#fafafa',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <SignatureCanvas
                  ref={signaturePadRef}
                  canvasProps={{
                    width: 500,
                    height: 200,
                    className: 'sigCanvas',
                    style: {
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      backgroundColor: 'white'
                    }
                  }}
                  backgroundColor="white"
                  penColor="black"
                />
              </Box>
              <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>
                Please sign within the box above
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleSignatureClear} color="secondary" variant="outlined">
                Clear
              </Button>
              <Button onClick={handleSignatureClose} color="secondary">
                Cancel
              </Button>
              <Button onClick={handleSignatureSave} variant="contained" color="primary">
                Save Signature
              </Button>
            </DialogActions>
          </Dialog>

          <Divider sx={{ my: 2 }} />
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', gap: 2, marginTop: 3 }}>
              <DraftSaveButton
                formKey={DRAFT_KEYS.HIGH_RISK_CONSENT}
                uhidNo={uhid_no}
                formData={{ ...formData, patient_signature: '', witness_signature: '', doctor_anaesthetist_signature: '', interpreter_signature: '', patient_rep_signature: '', witness_signature_unable_consent: '', doctor_signature_unable_consent: '', interpreter_signature_unable_consent: '' }}
                onDraftLoaded={(draftData) => setFormData(draftData)}
                variant="outlined"
                size="large"
                isUpdate={success}
              />
              <Button variant="contained" color="primary" fullWidth onClick={handleHighRickConsentSubmit}>
                {success ? 'Update' : 'Submit'}

              </Button>
            </Box></Grid>
        </Paper>
      </Container>
    </ThemeProvider>
  );
};

export default HighRiskConsentForm;